import Vue from 'vue'
import Router from 'vue-router'
// import Hello from '@/components/Hello'

Vue.use(Router)

// TODO；管理权限分配相应路由
export default new Router({
  routes: [
    {
      name: 'login',
      path: '/login',
      component: resolve => require(["../components/login.vue"], resolve),
      meta: {

      }
    },
    {
      path: '/overview',
      name: 'overview',
      component: resolve => require(["../components/overview.vue"], resolve),
      children: [
        {
          path: 'device',
          name: "device",
          component: resolve => require(["../components/device/device.vue"], resolve),
        },
        {
          path: 'fault-device',
          name: "fault-device",
          component: resolve => require(["../components/fault/fault-site.vue"], resolve),

        },
        {
          path: 'fault-order',
          name: "fault-order",
          component: resolve => require(["../components/fault/fault-order.vue"], resolve),
          beforeEnter: (to, from, next) => {
            var type = sessionStorage.getItem("type")
            if(type && parseInt(type) <= 100){
              next()
            }else {
              next("/login")
            }
          }

        },
        {
          path: 'client',
          name: "client",
          component: resolve => require(["../components/user/client.vue"], resolve),
          beforeEnter: (to, from, next) => {
            // check current user permission
            var type = sessionStorage.getItem("type")
            if(type && parseInt(type) <= 100){
              next()
            }else{
              next("/login")
            }
          }

        },
        {
          path: 'role',
          name: "role",
          component: resolve => require(["../components/user/role.vue"], resolve),
          beforeEnter: (to, from, next) => {
            // check current user permission
            var type = sessionStorage.getItem("type")
            if(type && parseInt(type) <= 100){
              next()
            }else{
              next("/login")
            }
          }
        },
        {
          path: 'engineer',
          name: "engineer",
          component: resolve => require(["../components/user/engineer.vue"], resolve),
          beforeEnter: (to, from, next) => {
            // check current user permission
            var type = sessionStorage.getItem("type")
            if(type && parseInt(type) <= 110){
              next()
            }else{
              next("/login")
            }
          }
        },
        {
          path: 'app-auth',
          name: "app-auth",
          component: resolve => require(["../components/auth/app-auth.vue"], resolve),
          beforeEnter: (to, from, next) => {
            // check current user permission
            var type = sessionStorage.getItem("type")
            if(type && parseInt(type) <= 100){
              next()
            }else{
              next("/login")
            }
          }
        },
        {
          path: 'magickey-auth',
          name: "magickey-auth",
          component: resolve => require(["../components/auth/magickey-auth.vue"], resolve),
          beforeEnter: (to, from, next) => {
            // check current user permission
            var type = sessionStorage.getItem("type")
            if(type && parseInt(type) <= 100){
              next()
            }else{
              next("/login")
            }
          }
        },
        {
          path: 'project-doc',
          name: "project-doc",
          component: resolve => require(["../components/project/project-layout.vue"], resolve),
          children: [
            // {
            //   path: 'doc-table',
            //   name: "doc-table",
            //   component: resolve => require(["../components/project/doc-table.vue"], resolve),
            // },
            // {
            //   path: "",
            //   name: "doc-table",
            //   component: resolve => require(["../components/project/doc-table.vue"],resolve)
            // }
          ]
        },
        // {
        //   path: "",
        //   component: resolve => require(["../components/device/device.vue"], resolve)
        // },
        {
          path: "*",
          component: resolve => require(["../components/device/device.vue"], resolve),
          // beforeEnter: (to, from, next) => {
          //   if(sessionStorage.getItem("accessToken")){
          //     next("/overview/life-cycle")
          //   }else{
          //     next("/overview/life-cycle")
          //   }
          // }
        }
      ],
      beforeEnter: (to, from, next) => {
        // check current user permission
        var token = sessionStorage.getItem("accessToken")
        if(token){
          next()
        }else{
          next("/login")
        }
      }
    },
    // {
    //   path: '/',
    //   redirect: {
    //     name: 'overview'
    //   }
    // },
    {
      path: '*',
      component: resolve => require(["../components/login.vue"], resolve)
      // redirect: {
      //   name: 'overview'
      // }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js